import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SvgIcon from '@mui/material/SvgIcon';

function FontIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M15.5714 14.8571H14.25L9.25 0.392857C9.17857 0.178571 8.92857 0 8.71429 0H8.14286C7.89286 0 7.64286 0.178571 7.57143 0.392857L2.57143 14.8571H1.28571C1.10714 14.8571 1 15 1 15.1429V15.7143C1 15.8929 1.10714 16 1.28571 16H5.28571C5.42857 16 5.57143 15.8929 5.57143 15.7143V15.1429C5.57143 15 5.42857 14.8571 5.28571 14.8571H3.78571L5.35714 10.2857H11.4643L13.0357 14.8571H11.5714C11.3929 14.8571 11.2857 15 11.2857 15.1429V15.7143C11.2857 15.8929 11.3929 16 11.5714 16H15.5714C15.7143 16 15.8571 15.8929 15.8571 15.7143V15.1429C15.8571 15 15.7143 14.8571 15.5714 14.8571ZM5.75 9.14286L8.42857 1.5L11.0714 9.14286H5.75Z" fill="#525A63" />
    </SvgIcon>
  )
}

const LetterFilterMenu = props => {
  return (
    <Menu
      elevation={0}
      open={props.open}
      anchorEl={props.anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={props.handleRequestClose}
      keepMounted
    >
      <MenuItem onClick={() => props.handleClickFilterLetterFontStyle('TRADITIONAL')}>
        <ListItemIcon>
          <FontIcon viewBox="0 0 11 16" style={{color: '#525A63', fontSize: 16}} />
        </ListItemIcon>
        <ListItemText primary="Traditional" />
      </MenuItem>

      <MenuItem onClick={() => props.handleClickFilterLetterFontStyle('BOOK')}>
        <ListItemIcon>
          <FontIcon viewBox="0 0 11 16" style={{color: '#525A63', fontSize: 16}} />
        </ListItemIcon>
        <ListItemText primary="Book" />
      </MenuItem>
    </Menu>
  );
};

LetterFilterMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  handleRequestClose: PropTypes.func.isRequired,
  handleClickFilterLetterFontStyle: PropTypes.func.isRequired,
};

export default LetterFilterMenu;
